const MPC_AXIS_COUNT = 20;

export const MPC_X_AXIS_TITLE_KEYS = Array.from({ length: MPC_AXIS_COUNT }, (_, i) => {
  const n = i === 0 ? "" : `${i + 1}`;
  return `xAxis${n}TitleText`;
});

export const MPC_Y_AXIS_TITLE_KEYS = Array.from({ length: MPC_AXIS_COUNT }, (_, i) => {
  const n = i === 0 ? "" : `${i + 1}`;
  return `yAxis${n}TitleText`;
});

export const MPC_AXIS_TITLE_KEYS = [...MPC_X_AXIS_TITLE_KEYS, ...MPC_Y_AXIS_TITLE_KEYS];

export const ALL_POSSIBLE_GRIDLINE_KEYS = Array.from(
  { length: MPC_AXIS_COUNT },
  (_, i) => {
    const n = i === 0 ? "" : `${i + 1}`;
    return [
      `gridShowX${n}Lines`,
      `gridShowX${n}MinorLines`,
      `gridShowY${n}Lines`,
      `gridShowY${n}MinorLines`
    ];
  }
).flat();

export const isGridlineKey = (name: string): boolean =>
  /^gridShow[XY]\d*(Minor)?Lines$/.test(name);

export const SCREENSHOT_MODE_BODY_CLASS = "screenshot-mode";

export const DASHBOARD_SCREENSHOT_MODE_BODY_CLASS = "dashboard-screenshot-mode";
